import { useEffect } from 'react'
import { useLoadSdkYuno } from '../../hooks'
import { UsePaymentStatus } from './payment-status.types'
import { useTranslation } from 'react-i18next'
import {
  getCheckoutReturnUrlInLS,
  getPaymentIdInLS,
  getPublicApiKeyInLS,
  getShowResultScreenInLS,
} from '../../utils/local-storage'
import { CountryCode } from '@yuno/sdk-web-core/dist/types'
import { buildCallbackUrl, redirectAfterResultScreen, redirectTo } from '../../utils'
import { dispatchLoaderEvent } from '../../utils/loader'

const FINAL_STATUSES = new Set(['SUCCEEDED', 'FAILED', 'CANCELLED', 'REJECTED', 'ERROR', 'DECLINED', 'EXPIRED'])

export const usePaymentStatus: UsePaymentStatus = (checkoutSession) => {
  const { isYunoLoaded } = useLoadSdkYuno()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (isYunoLoaded && checkoutSession) {
      initSdk()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYunoLoaded, checkoutSession])

  const initSdk = async () => {
    const publicApiKey = getPublicApiKeyInLS()
    const checkoutReturnUrl = getCheckoutReturnUrlInLS()
    const paymentId = getPaymentIdInLS()
    const showResultScreen = getShowResultScreenInLS()

    if (!publicApiKey) {
      throw new Error('There is not Public Api Key')
    }

    const yuno = await window.SdkPayments.initialize(publicApiKey)

    await yuno.mountStatusPayment({
      checkoutSession,
      countryCode: CountryCode.COLOMBIA,
      language: i18n.resolvedLanguage as Language,
      paymentResult(data) {
        if (checkoutReturnUrl?.length && FINAL_STATUSES.has(data)) {
          if (showResultScreen) {
            const url = buildCallbackUrl(checkoutReturnUrl, data, paymentId)
            redirectAfterResultScreen(url)
          } else {
            dispatchLoaderEvent({ showLoader: true })
            redirectTo(checkoutReturnUrl)
          }
        }
      },
    })
  }
}
